export default __webpack_public_path__ + "static/media/swingleft_dragcon.21315c5e.jpg";